// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__16Z5z","productName":"Table_productName__2puS4"};